import {AxiosRequestConfig} from 'axios';
import {ReportReq} from '../types';

export const getReports = (request: ReportReq): AxiosRequestConfig => ({
	method: 'POST',
	url: '/logists-report',
	data: request
});